import "./EventSuggestionDialog.scss";

export default {
  name: "EventSuggestionDialog",
  data: () => ({
    currentPage: 1
  }),
  computed: {
    categoryTabCount() {
      return this.getTabSuggestionCount("category");
    },
    featureTabCount() {
      return this.getTabSuggestionCount("feature");
    },
    showStatusLabel() {
      return Boolean(this.dialogStatusLabel);
    },
    totalPages() {
      if (!this.enablePagination) return 1;
      const safeItemsPerPage = Math.max(Number(this.itemsPerPage) || 1, 1);
      return Math.max(Math.ceil(this.dialogItems.length / safeItemsPerPage), 1);
    },
    pagedDialogItems() {
      if (!this.enablePagination) {
        return this.dialogItems;
      }
      const safeItemsPerPage = Math.max(Number(this.itemsPerPage) || 1, 1);
      const start = (this.currentPage - 1) * safeItemsPerPage;
      return this.dialogItems.slice(start, start + safeItemsPerPage);
    },
    showPager() {
      return this.enablePagination && this.totalPages > 1;
    }
  },
  watch: {
    categoryDialogOpen(isOpen) {
      if (isOpen) {
        this.currentPage = 1;
      }
    },
    currentSuggestionType() {
      this.currentPage = 1;
    },
    dialogItems() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    }
  },
  methods: {
    switchTab(type) {
      this.$emit("switch-tab", type);
    },
    nextPage() {
      if (this.currentPage >= this.totalPages) return;
      this.currentPage += 1;
    },
    previousPage() {
      if (this.currentPage <= 1) return;
      this.currentPage -= 1;
    }
  },
  props: {
    categoryDialogOpen: {
      type: Boolean,
      default: false
    },
    currentSuggestionType: {
      type: String,
      default: "category"
    },
    dialogTitleLabel: {
      type: String,
      default: ""
    },
    selectionLabel: {
      type: String,
      default: ""
    },
    dialogSubtitleLabel: {
      type: String,
      default: ""
    },
    suggestionTypeLabel: {
      type: String,
      default: ""
    },
    suggestionTypeSingularLabel: {
      type: String,
      default: ""
    },
    dialogItems: {
      type: Array,
      default: () => []
    },
    enablePagination: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 20
    },
    appliedSuggestionsById: {
      type: Object,
      default: () => ({})
    },
    suggestingItemId: {
      type: [String, Number],
      default: null
    },
    suggestionErrorsById: {
      type: Object,
      default: () => ({})
    },
    suggestedCategoriesById: {
      type: Object,
      default: () => ({})
    },
    suggestingCategories: {
      type: Boolean,
      default: false
    },
    applyingCategories: {
      type: Boolean,
      default: false
    },
    applyCompleted: {
      type: Boolean,
      default: false
    },
    suggestionsCompleted: {
      type: Boolean,
      default: false
    },
    hasSuggestionsToApply: {
      type: Boolean,
      default: false
    },
    totalSuggestionCount: {
      type: Number,
      default: 0
    },
    currentItemsCount: {
      type: Number,
      default: 0
    },
    dialogStatusLabel: {
      type: String,
      default: ""
    },
    actionButtonLabel: {
      type: String,
      default: ""
    },
    getTitle: {
      type: Function,
      required: true
    },
    getMainCategoryLabel: {
      type: Function,
      default: () => ""
    },
    getCurrentLabels: {
      type: Function,
      required: true
    },
    getAppliedStateForItem: {
      type: Function,
      required: true
    },
    getSuggestionsForItem: {
      type: Function,
      required: true
    },
    getSuggestionErrorForItem: {
      type: Function,
      required: true
    },
    isItemLoadingSuggestions: {
      type: Function,
      required: true
    },
    getTabSuggestionCount: {
      type: Function,
      required: true
    },
    getStartTime: {
      type: Function,
      default: () => ""
    },
    getLocation: {
      type: Function,
      default: () => ""
    },
    getItemStateKey: {
      type: Function,
      required: true
    }
  }
};
